<script>
	import SharedUsers from './SharedUsers.svelte';
	import SingleUser from './SingleUser.svelte';

	export let position = 1;
	export let last = false;
	export let users = [];
	export let userId = '';

	const getEmoji = (position) => {
		if (position === 1) {
			return '🚀';
		} else if (position === 2) {
			return '🎉';
		} else if (position === 3) {
			return '🥉';
		}
		return '';
	};

	const getText = (position) => {
		if (position >= 2) {
			return 'It’s a Shared Position!';
		}
		return 'Woah! Shared Position!';
	};
	// let users = [
	// 	{
	// 		name: 'Asim Aashish',
	// 		id: 1,
	// 		score: 50,
	// 		src: 'https://t3.ftcdn.net/jpg/02/22/85/16/360_F_222851624_jfoMGbJxwRi5AWGdPgXKSABMnzCQo9RN.jpg'
	// 	},
	// 	{ name: 'Anindya Choudhary', id: 2, score: 50 },
	// 	{ name: 'Om Prakash', id: 3, score: 40 },
	// 	{ name: 'Aman Kapoor', id: 4, score: 40 },
	// 	{ name: 'Nitesh', id: 5, score: 30 },
	// 	{ name: 'Very big name omg', id: 6, score: 20 },
	// 	{ name: 'lmao xdffdf gg', id: 7, score: 20 },
	// 	{ name: 'Harshit Malobocha', id: 8, score: 10 },
	// 	{ name: 'Nitesh asdf', id: 9, score: 9 },
	// 	{ name: 'Very big name omg', id: 10, score: 8 },
	// 	{ name: 'lmao xdasdf gg', id: 11, score: 8 },
	// 	{ name: 'Harshit Malobocha', id: 12, score: 7 }
	// ];
</script>

{#if users?.length === 1}
	<SingleUser {position} user={users[0]} {userId} />
{:else if users?.length > 1 && position > 3}
	{#each users as user}
		<SingleUser {position} {user} {userId} />
	{/each}
{:else if users?.length > 0}
	<SingleUser
		{position}
		user={{ name: getText(position), score: users[0].score }}
		text={getEmoji(position)}
		shared={true}
	/>

	<SharedUsers {userId} {users} {position} />
{/if}

<style>
</style>
